<template>
  <div class="brick" :style="style"></div>
</template>

<script>

export default {
  name: 'BrickComponent',
  props: {
    style: {
      type: Object,
      default: () => ({}),
    },
    i: {
      type: Array,
    },
  },
  // created() {
  //   console.log('BrickComponent created', {
  //     style: this.style,
  //     i: this.i,
  //   });
  // },
}
</script>
